import {
    HospitalOrganizationRelationListingModel as BaseModel,
    IHospitalOrganizationRelationListingModel as BaseInterface,
    IOrganizationListingModel,
    OrganizationListingModel

} from '@common/models';


export interface IHospitalOrganizationRelationListingModel extends BaseInterface {
    corpOrgModel: IOrganizationListingModel
}

//The base model is in common, this one inherits it and adds a hospital specific read only field, they have the same name on purpose
export class HospitalOrganizationRelationListingModel extends BaseModel implements IHospitalOrganizationRelationListingModel {
    corpOrgModel: IOrganizationListingModel;

    constructor(params: Partial<IHospitalOrganizationRelationListingModel>) {
        super(params);

        const {
            corpOrgModel = {}
        } = params;

        this.corpOrgModel = new OrganizationListingModel(corpOrgModel);
    }

    get isReadOnly(): boolean {
        return this.corpOrgModel.organizationId === this.organizationId; //don't let users delete corp org if there is one.
    }
}
